(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["norla-assurance"] && !Shopify.designMode) return;
  try {
    // Counts down to the shop's daily dispatch cutoff. The shop's UTC offset is
  // rendered server-side so a visitor in another timezone still sees the real
  // deadline instead of one shifted by their own clock.
  class NorlaCutoff extends HTMLElement {
    connectedCallback() {
      this.cutoffHour = parseInt(this.dataset.cutoffHour, 10);
      if (Number.isNaN(this.cutoffHour)) return;

      const offset = this.dataset.shopOffset || '+0000';
      const sign = offset[0] === '-' ? -1 : 1;
      this.offsetMinutes =
        sign * (parseInt(offset.slice(1, 3), 10) * 60 + parseInt(offset.slice(3, 5), 10));

      this.render();
      this.timer = setInterval(() => this.render(), 60000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    render() {
      const shopNow = new Date(Date.now() + (this.offsetMinutes + new Date().getTimezoneOffset()) * 60000);
      const cutoff = new Date(shopNow);
      cutoff.setHours(this.cutoffHour, 0, 0, 0);

      const msLeft = cutoff - shopNow;
      if (msLeft <= 0) {
        this.textContent = this.dataset.labelAfter;
        return;
      }

      const hours = Math.floor(msLeft / 3600000);
      const minutes = Math.floor((msLeft % 3600000) / 60000);
      const time = hours > 0 ? `${hours} h ${minutes} m` : `${minutes} m`;

      this.innerHTML = this.dataset.labelBefore.replace('{' + '{ time }' + '}', `<strong>${time}</strong>`);
    }
  }

  if (!customElements.get('norla-cutoff')) {
    customElements.define('norla-cutoff', NorlaCutoff);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["norla-collapsible-text"] && !Shopify.designMode) return;
  try {
    // Only shows the toggle when the text actually overflows its clamp, so a
  // short description never gets a pointless "Show more" button.
  function initCollapsibleText(root) {
    const body = root.querySelector('[ref="body"]');
    const toggle = root.querySelector('[ref="toggle"]');
    if (!body || !toggle || root.__nrlCtInit) return;
    root.__nrlCtInit = true;

    const overflowing = body.scrollHeight - body.clientHeight > 2;
    if (!overflowing) return;
    toggle.hidden = false;

    toggle.addEventListener('click', () => {
      const expanded = root.classList.toggle('is-expanded');
      toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    });
  }

  function runAll() {
    document.querySelectorAll('.nrl-ct').forEach(initCollapsibleText);
  }

  if (document.readyState !== 'loading') runAll();
  else document.addEventListener('DOMContentLoaded', runAll);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.nrl-ct').forEach(initCollapsibleText);
  });
  } catch(e) { console.error(e); }
})();

})();
